// extracted by css-extract-rspack-plugin
module.exports =  {"base":"ScopeChangeRequestBreakdownTable__base___y_Yw3"};